import { useSyncExternalStore } from 'react';
const eventName = 'tequisa-current-order';
const retention = 24 * 60 * 60 * 1000;
export const currentOrderKey = (mode: string, identity = 'guest') => `tequisa-current-order-${JSON.stringify([mode, identity])}`;
export function readCurrentOrder(key: string): string | null {
  try {
    const record = JSON.parse(sessionStorage.getItem(key) ?? 'null');
    if (typeof record?.credential !== 'string' || !record.credential || !Number.isFinite(record.at) || record.at > Date.now() || Date.now() - record.at >= retention) return null;
    return record.credential;
  } catch { return null; }
}
export function rememberCurrentOrder(key: string, credential: string) {
  try { sessionStorage.setItem(key, JSON.stringify({ credential, at: Date.now() })); } catch { /* The open receipt still works when storage is unavailable. */ }
  window.dispatchEvent(new Event(eventName));
}
export function forgetCurrentOrder(key: string) {
  try { sessionStorage.removeItem(key); } catch { /* Best effort on restricted devices. */ }
  window.dispatchEvent(new Event(eventName));
}
const subscribe = (listener: () => void) => {
  window.addEventListener(eventName, listener); window.addEventListener('storage', listener);
  return () => { window.removeEventListener(eventName, listener); window.removeEventListener('storage', listener); };
};
export function useCurrentOrder(key: string) { return useSyncExternalStore(subscribe, () => readCurrentOrder(key)); }
